import { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, useGSAP);

/**
 * Parallax scroll-driven reutilizable: desplaza el elemento con scrub
 * mientras su sección atraviesa el viewport, creando profundidad.
 *
 * Uso:
 *   const ref = useParallax({ y: -20 });      // sube 20% de su alto
 *   <img ref={ref} ... />                     // capas decorativas, nunca texto largo
 *
 * `trigger` por defecto es el elemento padre (la sección que scrollea).
 */
export default function useParallax(options = {}) {
    const ref = useRef(null);
    const { y = -15, x = 0, scale = null, start = 'top bottom', end = 'bottom top' } = options;

    useGSAP(() => {
        if (!ref.current) return;

        const vars = {
            yPercent: y,
            xPercent: x,
            ease: 'none',
            scrollTrigger: {
                trigger: ref.current.parentElement || ref.current,
                start,
                end,
                scrub: true,
            },
        };
        if (scale !== null) vars.scale = scale;
        gsap.to(ref.current, vars);
    }, { scope: ref });

    return ref;
}
